import classNames from 'clsx';
import React, { memo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPublicUrl } from 'reactApp/appHelpers/appHelpers';
import { AccessStatus } from 'reactApp/components/SharingNew/SharingNew.types';
import { getItemById, isMountedOrSharedFolder } from 'reactApp/modules/storage/storage.selectors';
import { RootState } from 'reactApp/store';
import { AccessRights } from 'reactApp/types/Tree';
import { sendGa } from 'reactApp/utils/ga';

import styles from './EmptyFolder.css';
import { useEmptyFolderContent } from './EmptyFolder.hooks';
import { EItemType, gaSuffix, IProps } from './EmptyFolder.types';

export const EmptyFolder = memo(function EmptyFolder(props: IProps) {
    const { folder } = props;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isAlbum = folder?.type === 'album';
    const publicUrl = getPublicUrl(folder);
    const emptyFolderContent = useEmptyFolderContent(folder?.id || '', publicUrl, isAlbum);
    const isSharedOrMouted = useSelector((state: RootState) => isMountedOrSharedFolder(state, folder));
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const parent = useSelector((state: RootState) => getItemById(state, folder?.parent));
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isReadOnlyItem = folder?.isReadOnly;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isReadOnly = !isReadOnlyItem && isSharedOrMouted.isMounted ? parent?.isReadOnly : isReadOnlyItem;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isPublicReadWrite = folder?.weblinkAccessRights === AccessRights.rw;
    const accessRights = isPublicReadWrite && !isReadOnly ? AccessStatus.Upload : AccessStatus.ReadOnly;

    const handleCm = useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
    }, []);

    useEffect(() => sendGa(gaSuffix, 'show'), []);

    return (
        <div className={styles.root} onContextMenu={handleCm}>
            {Object.entries(emptyFolderContent).map((data) => {
                const [type, itemData] = data;
                const item = itemData(accessRights);
                const shared = Boolean(type === EItemType.COSHARING && publicUrl);

                return (
                    <section
                        key={type}
                        role="presentation"
                        onClick={item.onClick}
                        className={classNames({
                            [styles.item]: true,
                            [styles[`item_type_${type}`]]: Boolean(type),
                            [styles.item_shared]: shared,
                        })}
                    >
                        <div className={styles.actionIcon}>{item.Icon}</div>
                        <h1 className={styles.header}>{item.title}</h1>
                        <p className={styles.annotation}>{item.annotation}</p>
                        {item.additionLinks}
                    </section>
                );
            })}
        </div>
    );
});
